import { render, staticRenderFns } from "./SvgExpoHall.vue?vue&type=template&id=065a0266&"
import script from "./SvgExpoHall.vue?vue&type=script&lang=js&"
export * from "./SvgExpoHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports